import "./LoginPage.scss";
import Logo from "../../../assets/logo.svg";
import { useAuth } from "../../../auth";
import { Button } from "@fsg/gui-bits";

function LoginPage() {
  const { login } = useAuth();
  return (
    <div className="login-page">
      <div className="image-wrapper">
        <img src={Logo} alt="FSG" />
      </div>
      <div>
        <Button
          onClick={() => {
            login();
          }}
        >
          Log in
        </Button>
      </div>
    </div>
  );
}

export default LoginPage;
